import { NewsLetterSubscription } from "../models/newslettersubscription.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getNewsletterSubscriptionList = (id: number): Promise<NewsLetterSubscription[]> => {
    return new Promise<NewsLetterSubscription[]>((resolve, reject) => {
        if(!id) return;
        
        responseHero.get(`${process.env.REACT_APP_API_URL}/newslettersubscription/${id}`).then((response) => {
            resolve(response.data as NewsLetterSubscription[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};